import { useState } from "react";

export default function useVisibleOptionsValues(initialValues) {
  const [values, setValues] = useState(initialValues);
  const [error, setError] = useState(null);
  const removeValue = i => {
    const newValues = [...values];
    newValues.splice(i, 1);
    setValues(newValues);
  };

  const setValue = value => {
    value = value.trim();
    if (values.indexOf(value) > -1) {
      return setError("Option already exists");
    }
    setError(null);
    setValues([...values, value]);
  };

  const cleanValues = () => {
    setValues([]);
  };

  return [values, setValue, removeValue, cleanValues, error];
}
